module.exports = __webpack_public_path__ + "img/customers.cbf890f4.svg";